// Public API service for frontend

import { API_BASE_URL as API } from '../config/apiConfig';

// ============== Delivery Quote ==============
export const getDeliveryQuote = async (destinationAddress) => {
  try {
    const response = await fetch(`${API}/delivery/quote`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ destinationAddress }),
    });
    
    if (!response.ok) {
      // Fallback on error
      return {
        distanceMiles: null,
        deliveryPrice: 10,
        note: 'Final delivery fee confirmed via WhatsApp',
      };
    }
    
    return response.json();
  } catch (error) {
    console.error('Delivery quote error:', error);
    // Return fallback on network error
    return {
      distanceMiles: null,
      deliveryPrice: 10,
      note: 'Final delivery fee confirmed via WhatsApp',
    };
  }
};

// ============== Orders ==============
export const createOrder = async (orderData) => {
  try {
    const response = await fetch(`${API}/orders`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(orderData),
    });
    
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.detail || 'Failed to create order');
    }
    
    return response.json();
  } catch (error) {
    console.error('Create order error:', error);
    throw error;
  }
};

export const getOrder = async (orderId) => {
  const response = await fetch(`${API}/orders/${orderId}`);
  
  if (!response.ok) {
    throw new Error('Order not found');
  }
  
  return response.json();
};

// ============== Pricing Config ==============
export const getPricingConfig = async () => {
  try {
    const response = await fetch(`${API}/pricing/config`);
    
    if (!response.ok) {
      throw new Error('Failed to fetch pricing config');
    }
    
    return response.json();
  } catch (error) {
    console.error('Pricing config error:', error);
    // Return default config on error
    return null;
  }
};

// ============== Checkout (Stripe) ==============
export const getPaymentStatus = async () => {
  try {
    const response = await fetch(`${API}/checkout/status`);
    
    if (!response.ok) {
      return { paymentsEnabled: false };
    }
    
    return response.json();
  } catch (error) {
    console.error('Payment status error:', error);
    return { paymentsEnabled: false };
  }
};

export const createCheckoutSession = async (orderId) => {
  const response = await fetch(`${API}/checkout/create-session`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ orderId }),
  });
  
  const data = await response.json();
  
  if (data.error) {
    throw new Error(data.error);
  }
  
  return data;
};

// ============== Gallery ==============
export const getPublicGallery = async () => {
  try {
    const response = await fetch(`${API}/gallery`);
    
    if (!response.ok) {
      return [];
    }
    
    return response.json();
  } catch (error) {
    console.error('Gallery error:', error);
    return [];
  }
};

export default {
  getDeliveryQuote,
  createOrder,
  getOrder,
  getPricingConfig,
  getPaymentStatus,
  createCheckoutSession,
  getPublicGallery,
};
